"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributionLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var styleUtilities_1 = require("../../../util/styleUtilities");
var Icon_1 = require("../../atoms/Icon/Icon");
var Link_1 = require("../../atoms/Link/Link");
var TextIcon_1 = require("../../atoms/TextIcon/TextIcon");
var AttributionLabel_static_1 = require("./AttributionLabel.static");
var AttributionLabel_style_1 = __importDefault(require("./AttributionLabel.style"));
/**
 * AttributionLabel molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-attributionlabel--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/AttributionLabel Source}
 */
var AttributionLabel = function (_a) {
    var _b = _a.icon, icon = _b === void 0 ? icons_1.default.microFrontend : _b, _c = _a.externalIcon, externalIcon = _c === void 0 ? icons_1.default.newTabCompact : _c, _d = _a.externalText, externalText = _d === void 0 ? AttributionLabel_static_1.localText.learnMore : _d, externalUrl = _a.externalUrl, message = _a.message, className = _a.className;
    var classes = (0, AttributionLabel_style_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.root, className) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.iconWrapper, "data-testid": 'icon-wrapper' }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.5), iconPath: icon, size: 20 }) })), renderMessage(), (0, jsx_runtime_1.jsx)(Link_1.Link, __assign({ url: externalUrl }, { children: (0, jsx_runtime_1.jsx)(TextIcon_1.TextIcon, { icon: externalIcon, text: externalText, fontVariant: 'headline3' }) }))] })));
    function renderMessage() {
        return (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.messageRoot }, { children: message }));
    }
};
exports.AttributionLabel = AttributionLabel;
